import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import type { ModuleRoute } from '@core/router/types';
import { Permissions } from '@core/auth/permissions';
import { DOCUMENTS_PATH } from './hooks/useDocumentNavigation';

const DocumentArchiveListPage = lazy(() => import('./pages/DocumentArchiveListPage'));
const DocumentDetailsPage = lazy(() => import('./pages/DocumentDetailsPage'));
const CatalogManagementPage = lazy(() => import('./pages/CatalogManagementPage'));

const CATALOG_PERMISSIONS = [Permissions.DocumentArchive.Catalogs.Manage, Permissions.DocumentArchive.Documents.ManageAll];

export const documentArchiveRoutes: ModuleRoute[] = [
  {
    index: true,
    element: <Navigate to="dokumenti" replace />,
  },
  {
    path: 'dokumenti',
    element: <DocumentArchiveListPage />,
    permission: Permissions.DocumentArchive.Module.Access,
    layout: 'wide',
    meta: {
      title: 'Arhiva dokumenata',
      icon: 'Inventory2',
      showInSidebar: true,
      order: 1,
    },
  },
  {
    // Adding documents is a dialog on the list now; old links still open it
    path: 'upload',
    element: <Navigate to={DOCUMENTS_PATH} replace state={{ openUpload: true }} />,
    permissions: [Permissions.DocumentArchive.Documents.Upload, Permissions.DocumentArchive.Documents.ManageAll],
  },
  {
    path: 'dokumenti/:id',
    element: <DocumentDetailsPage />,
    permissions: [Permissions.DocumentArchive.Documents.View, Permissions.DocumentArchive.Documents.ManageAll],
    layout: 'fullBleed',
    meta: { title: 'Detalj dokumenta', showInSidebar: false },
  },
  // One page per catalog; the key restarts the page (search, dialogs) when switching catalogs
  {
    path: 'tipovi-dokumenata',
    element: <CatalogManagementPage key="document-types" catalog="document-types" />,
    permissions: CATALOG_PERMISSIONS,
    meta: { title: 'Tipovi dokumenata', icon: 'Tag', showInSidebar: true, order: 2 },
  },
  {
    path: 'korespondenti',
    element: <CatalogManagementPage key="correspondents" catalog="correspondents" />,
    permissions: CATALOG_PERMISSIONS,
    meta: { title: 'Korespondenti', icon: 'Person', showInSidebar: true, order: 3 },
  },
  {
    path: 'tagovi',
    element: <CatalogManagementPage key="tags" catalog="tags" />,
    permissions: CATALOG_PERMISSIONS,
    meta: { title: 'Tagovi', icon: 'LocalOffer', showInSidebar: true, order: 4 },
  },
  {
    // The catalogs used to share one page; old links land on the first catalog
    path: 'katalozi',
    element: <Navigate to="/arhiva-dokumenata/tipovi-dokumenata" replace />,
  },
];
